<template>
  <v-container>
    <v-card class="elevation-2 mx-auto" :loading="loading" max-width="600">
      <v-card-title>Add Files</v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <form>
          <v-row>
            <v-col cols="12" md="12" sm="12" class="py-0">
              <v-text-field
                label="Title"
                v-model="form_data.file_title"
                :error-messages="form_error.file_title"
                outlined
                dense
                autofocus
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12" sm="12" class="py-0">
              <v-file-input
                v-model="form_data.file_name"
                :error-messages="form_error.file_name"
                placeholder="Select File"
                prepend-icon="mdi-file"
                outlined
                dense
                :rules="fileRules"
              ></v-file-input>
            </v-col>
          </v-row>
          <v-btn
            class="mr-4"
            color="secondary"
            @click="addFile"
            :loading="loading"
            :disabled="loading"
          >submit</v-btn>
        </form>
      </v-card-text>
    </v-card>
    <v-btn small color="secondary" fixed fab bottom left to="/file">
      <v-icon>mdi-arrow-left</v-icon>
    </v-btn>
  </v-container>
</template>
<script>
 
import { mapMutations } from "vuex";
export default {
  name: "AddFile",
  data() {
    return {
      form_data: {},
      form_error: {},
      loading: false,
      data: {},
      fileRules: [
        value => {
          return !value || value.size < 524288000 || 'File size should be less than 500 MB!'
        },
      ],
    };
  },
  methods: {
    ...mapMutations("utils", ["setAlert"]),
    addFile() {
      // validating the file
      if (this.form_data.file_name && this.form_data.file_name.size >= 524288000) {
        this.form_error.file_name = 'File size should be less than 300 MB!';
        return;
      }

      let _self = this;
      this.loading = "secondary";
      let serverData = JSON.parse(JSON.stringify(this._data.form_data));
      let formData = new FormData();
      for (let key in serverData) {
        formData.append(key, serverData[key]);
      }
      if (this.form_data.file_name) {
        formData.append("file_name", this.form_data.file_name);
      }
      this.$axios.post(`admin/file/add`, formData)
        .then((response) => {
          _self.form_error = {};
          let response_data = response.data;
          if (response_data.status) {
            _self.setAlert({
              show: true,
              variant: "success",
              message: response.data.message,
              dismissCountDown: 5000,
            });
            this.user_data = response_data.user_data;
            _self.$router.push("/file");
          } else {
            let errors = response_data.error;
            for (let key in errors) {
              _self.form_error[errors[key].field] = errors[key].message;
            }
          }
          _self.loading = false;
        })
        .catch((e) => {
          console.log(e);
          _self.loading = false;
        });
    },
  },
};
</script>